<div class="modal-body modal-scss">
  <div class="d-flex justify-content-between align-items-center mb-3">
    @if (canCreateEntrant) {
      <div class="square onHoverEntrant" id="Entrant" (click)="close('E')">
        <!-- ! petit tricks parce que le fillSVG ne fonctionne pas correctement sur un svg avec un polyline :D  -->
        <svg
          class="greyEntrant"
          width="58px"
          height="59px"
          viewBox="0 0 12.9981831 13.4994621"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <g id="Medium-Copy-34" transform="translate(-109.000000, -233.500538)" stroke="#4A4A4A" stroke-width="2">
              <g id="Group-5" transform="translate(109.000000, 233.500538)">
                <polyline
                  id="Path-2"
                  points="3.01154927 2.50046398 -1.56632324e-16 2.50046398 0 13.4994621 12.9981831 13.4994621 12.9981831 2.50046398 9.84940583 2.50046398"></polyline>
                <path
                  d="M6.49149171,0 L6.49149171,9.99992398 M6.49149171,9.99992398 L9.52997847,6.99946213 M3.39238704,6.99946213 L6.49909156,9.99992398"
                  id="Combined-Shape"></path>
              </g>
            </g>
          </g>
        </svg>
        <svg
          class="whiteEntrant"
          width="58px"
          height="59px"
          viewBox="0 0 12.9981831 13.4994621"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <g id="Medium-Copy-34" transform="translate(-109.000000, -233.500538)" stroke="#FFFFFF" stroke-width="2">
              <g id="Group-5" transform="translate(109.000000, 233.500538)">
                <polyline
                  id="Path-2"
                  points="3.01154927 2.50046398 -1.56632324e-16 2.50046398 0 13.4994621 12.9981831 13.4994621 12.9981831 2.50046398 9.84940583 2.50046398"></polyline>
                <path
                  d="M6.49149171,0 L6.49149171,9.99992398 M6.49149171,9.99992398 L9.52997847,6.99946213 M3.39238704,6.99946213 L6.49909156,9.99992398"
                  id="Combined-Shape"></path>
              </g>
            </g>
          </g>
        </svg>
        <p class="answerTitle" data-test="entrant">{{ 'modals.incomingMail' | translate }}</p>
      </div>
    }
    @if (canCreateSortant) {
      <div class="square fillSVG" id="Sortant" (click)="close('S')">
        <svg
          width="58px"
          height="59px"
          viewBox="0 0 15 15"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Medium-Copy-34" transform="translate(-107.991492, -295.000000)" fill="#4A4A4A" fill-rule="nonzero">
              <path
                d="M122.928641,295.586957 C122.898653,295.586957 122.898653,295.586957 122.928641,295.586957 C122.838678,295.358696 122.658751,295.163043 122.478825,295.065217 C122.418849,295.032609 122.358873,295 122.298898,295 C122.118971,295 121.939045,295 121.789106,295.065217 C121.759118,295.065217 121.729131,295.097826 121.729131,295.097826 L108.534518,301.293478 C108.23464,301.456522 107.994738,301.782609 107.994738,302.141304 C107.96475,302.5 108.144677,302.858696 108.444555,303.054348 L112.792951,305.663043 L112.792951,309.021739 C112.792951,309.413043 113.002865,309.771739 113.33273,309.902174 C113.452681,309.967391 113.572632,310 113.692583,310 C113.902498,310 114.1424,309.902174 114.292338,309.73913 L116.27153,307.75 L119.240318,309.543478 C119.48022,309.706522 119.780098,309.706522 120.049988,309.576087 C120.319877,309.445652 120.499804,309.184783 120.559779,308.891304 L122.9588,296.173913 C123.018775,296.01087 122.988788,295.782609 122.928812,295.586957 L122.928641,295.586957 Z M113.572461,303.869565 L110.933538,302.271739 L118.1306,298.880435 L113.572461,303.869565 Z M114.596153,306.83913 L114.596153,306.73913 L114.683653,306.78913 L114.596153,306.83913 Z M119.060392,307.195652 L115.1918,304.847826 L120.589596,298.978261 L119.060392,307.195652 Z"
                id="Shape"></path>
            </g>
          </g>
        </svg>
        <p class="answerTitle" data-test="sortant">{{ 'modals.outgoingMail' | translate }}</p>
      </div>
    }
    <div class="square fillSVG" id="Interne" (click)="close('I')">
      <svg width="58px" height="59px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Medium-Copy-34" transform="translate(-108.500000, -331.000000)" fill="#4A4A4A" fill-rule="nonzero">
            <path
              d="M122.241367,336.466356 L116.096156,331.202106 C115.776154,330.932631 115.285292,330.932631 114.965267,331.202106 L108.798718,336.466356 C108.606714,336.632178 108.5,336.860175 108.5,337.088155 L108.5,345.171058 C108.5,345.627017 108.883999,346 109.353425,346 L121.643848,346 C122.113273,346 122.497273,345.627017 122.497273,345.171058 L122.497273,337.088155 C122.518706,336.860168 122.411987,336.632196 122.241268,336.466356 L122.241367,336.466356 Z M116.5,344 L114.5,344 L114.5,341 L116.5,341 L116.5,344 Z M120.499856,344 L118.080537,344 L118.080537,340.147005 C118.080537,339.707804 117.717706,339.348529 117.274158,339.348529 L113.725698,339.348529 C113.28215,339.348529 112.919319,339.707804 112.919319,340.147005 L112.919319,344 L110.5,344 L110.5,337.372051 L115.5,333 L120.5,337.372051 L120.499856,344 Z"
              id="Shape"></path>
          </g>
        </g>
      </svg>
      <p class="answerTitle" data-test="interne">{{ 'modals.internalMail' | translate }}</p>
    </div>
    @if (canCreateEmail) {
      <div class="square" id="EXCHANGE" (click)="openExchange()">
        <i class="bi bi-mailbox icon"></i>
        <p class="answerTitle" data-test="exchange">{{ 'modals.email' | translate }}</p>
      </div>
    }
  </div>
  <i-button styleClass="bottomButton red " id="cancelCourrierCreation" (click)="close()" [text]="'cancel' | translate"></i-button>
</div>
